<template>
  <div>
    <ul :class="navTabsClass">
      <li
        v-for="(tab, idx) in tabs"
        :key="`tktab-navItem__${idx}`"
        :class="[navItemClass, { [activeClass]: idx === selectedIndex }]"
        @click="selectTab(idx)"
      >
        <slot
          name="title"
          :title="tab.title"
          :tab-index="idx"
          :disabled="tab.disabled"
        >
          {{ tab.title }}
        </slot>
      </li>
    </ul>
    <div :class="contentClass">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TkTabs',
  props: {
    navTabsClass: {
      type: String,
      default: '',
    },
    activeClass: {
      type: String,
      default: 'active',
    },
    contentClass: {
      type: [Array, String],
      default: null,
    },
    navItemClass: {
      type: String,
      default: '',
    },
    activeTabIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      selectedIndex: -1,
      tabs: [],
    }
  },
  watch: {
    selectedIndex(val) {
      this.tabs.forEach((tab, index) => {
        tab.isActive = index === val
      })
    },
  },
  mounted() {
    this.tabs = this.$children.filter((child) => child._isTab)
    this.selectedIndex =
      this.activeTabIndex < this.tabs.length ? this.activeTabIndex : 0
  },
  methods: {
    selectTab(i) {
      const targetTab = this.tabs[i]
      if (targetTab.disabled || this.selectedIndex === i) return false
      this.selectedIndex = i
      this.$emit('select-tab', {
        tabIndex: this.selectedIndex,
        title: targetTab.title,
      })
    },
  },
}
</script>
